import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  client: {
    NEXT_PUBLIC_SUPABASE_PROJECT_ID: z.string().optional(),
    NEXT_PUBLIC_WS_URL: z.string().min(1),
    NEXT_PUBLIC_WS_PAIRING_NAMESPACE: z.string().min(1),
    NEXT_PUBLIC_WS_AUTHENTICATED_SCREEN_NAMESPACE: z.string().min(1),
    NEXT_PUBLIC_SERVER_URL: z.string().min(1),
    NEXT_PUBLIC_PLAYER_URL: z.string().min(1),
    NEXT_PUBLIC_PROXY_SERVER_URL: z.string().min(1),
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
    NEXT_PUBLIC_SCRIPTS_URL: z.string().min(1),
    NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH: z.string().min(1),
    NEXT_PUBLIC_ASSETS_URL: z.string().min(1),
    NEXT_PUBLIC_SUPABASE_TEST_EMAIL: z.string().email().optional(),
    NEXT_PUBLIC_SUPABASE_TEST_PASSWORD: z.string().optional(),
    NEXT_PUBLIC_GZ_ANALYTICS_SCRIPT_URL: z.string().optional(),
    NEXT_PUBLIC_GZ_ANALYTICS_SYSTEM_ID: z.string().optional(),
    NEXT_PUBLIC_SHIFT_SECRET: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_PLACES_API_KEY: z.string(),
    NEXT_PUBLIC_PEXELS_API_KEY: z.string(),
  },
  // If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
  //   runtimeEnv: {
  //     DATABASE_URL: process.env.DATABASE_URL,
  //     OPEN_AI_API_KEY: process.env.OPEN_AI_API_KEY,
  //     NEXT_PUBLIC_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_PUBLISHABLE_KEY,
  //   },
  //   For Next.js >= 13.4.4, you only need to destructure client variables:
  experimental__runtimeEnv: {
    NEXT_PUBLIC_SUPABASE_PROJECT_ID:
      process.env.NEXT_PUBLIC_SUPABASE_PROJECT_ID,
    NEXT_PUBLIC_WS_URL: process.env.NEXT_PUBLIC_WS_URL,
    NEXT_PUBLIC_WS_PAIRING_NAMESPACE:
      process.env.NEXT_PUBLIC_WS_PAIRING_NAMESPACE,
    NEXT_PUBLIC_WS_AUTHENTICATED_SCREEN_NAMESPACE:
      process.env.NEXT_PUBLIC_WS_AUTHENTICATED_SCREEN_NAMESPACE,
    NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
    NEXT_PUBLIC_PLAYER_URL: process.env.NEXT_PUBLIC_PLAYER_URL,
    NEXT_PUBLIC_PROXY_SERVER_URL: process.env.NEXT_PUBLIC_PROXY_SERVER_URL,
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
    NEXT_PUBLIC_SCRIPTS_URL: process.env.NEXT_PUBLIC_SCRIPTS_URL,
    NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH:
      process.env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH,
    NEXT_PUBLIC_ASSETS_URL: process.env.NEXT_PUBLIC_ASSETS_URL,
    NEXT_PUBLIC_SUPABASE_TEST_EMAIL:
      process.env.NEXT_PUBLIC_SUPABASE_TEST_EMAIL,
    NEXT_PUBLIC_SUPABASE_TEST_PASSWORD:
      process.env.NEXT_PUBLIC_SUPABASE_TEST_PASSWORD,
    NEXT_PUBLIC_GZ_ANALYTICS_SCRIPT_URL:
      process.env.NEXT_PUBLIC_GZ_ANALYTICS_SCRIPT_URL,
    NEXT_PUBLIC_GZ_ANALYTICS_SYSTEM_ID:
      process.env.NEXT_PUBLIC_GZ_ANALYTICS_SYSTEM_ID,
    NEXT_PUBLIC_SHIFT_SECRET: process.env.NEXT_PUBLIC_SHIFT_SECRET,
    NEXT_PUBLIC_GOOGLE_PLACES_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY,
    NEXT_PUBLIC_IS_DEV: process.env.NEXT_PUBLIC_IS_DEV,
    NEXT_PUBLIC_PEXELS_API_KEY: process.env.NEXT_PUBLIC_PEXELS_API_KEY,
  },
});
